import { useQuery, UseQueryOptions } from 'react-query';

import { Stat, Guid } from '../../models';
import { useApi } from '../../context';
import { AxiosUtils } from '../../utils';
import { CerebroApiEndpoints } from '../../utils/api';
import { QueryKeys } from '.';

export function useDataRoomAccessLogsQuery(
	guid: Guid | undefined,
	userGuid: Guid | null | undefined,
	options?: Omit<UseQueryOptions<Stat[], unknown, Stat[], any>, 'queryKey' | 'queryFn'> | undefined
) {
	const api = useApi();

	return useQuery(
		QueryKeys.DataRoom.AccessLogs(guid, userGuid),
		() => AxiosUtils.getResponseData<Stat[]>(api.get(CerebroApiEndpoints.DataRooms.AccessLogs(guid, userGuid))),
		options
	);
}
